import { useState } from 'react'

import Input from 'common/components/input'

const SearchInput = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState('')

  const handleChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
    if (value === '') {
      onSearch('')
      return
    }

    onSearch(value)
  }

  return (
    <Input
      type="search"
      className="w-60"
      placeholder="Search"
      data-testid="language-rule-search"
      aria-label="language rule search"
      value={searchValue}
      onChange={handleChange}
    />
  )
}

export default SearchInput
